module.exports = __webpack_public_path__ + "static/media/blue_img_d.ca4fe150.png";